import { useSelector } from '@/api/state';
import { FC, useEffect, type JSX } from 'react';
import { useDispatch } from 'react-redux';

import {
  PublicEntityTemplate,
  PublicHydratedEntityTemplate,
  TemplatableEntity,
} from '@payaca/types/entity-templates';
import { parseHtmlToReact } from '@payaca/utilities/htmlUtilities';
import './EntityTemplateReadView.sass';

import './EntityTemplateTaskReadView.sass';

import { Alert } from '@payaca/ambrosia';
import * as formActions from '@payaca/store/forms/formsActions';

type Props = {
  entityTemplate: PublicEntityTemplate<'task'>;
  onUpdateEntityTemplateSuccess?: (
    updatedEntityTemplate: PublicHydratedEntityTemplate<TemplatableEntity>
  ) => void;
};
const EntityTemplateTaskReadView: FC<Props> = ({
  entityTemplate,
  onUpdateEntityTemplateSuccess,
}: Props): JSX.Element | null => {
  const dispatch = useDispatch();

  useEffect(() => {
    // get available forms
    dispatch(formActions.requestGetAvailableForms());
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'dispatch'
  }, []);

  const availableForms = useSelector((state) => state.forms.availableForms);
  const form = availableForms.find(
    (f) => f.value.toString() == entityTemplate.data.formTemplateId
  );

  if (!entityTemplate) return null;

  return (
    <div className={'entity-template-task-read-view'}>
      <div>
        {entityTemplate?.data.name && (
          <h1 className="name">{entityTemplate?.data.name}</h1>
        )}
      </div>
      {entityTemplate?.data.notes && (
        <div className="notes">
          <div className="label">Notes</div>
          <div>{parseHtmlToReact(entityTemplate.data.notes)}</div>
        </div>
      )}
      {!!entityTemplate?.data.checklistItems?.length && (
        <div className="checklist-items">
          <div className="label">Checklist Items</div>
          <ul>
            {entityTemplate?.data.checklistItems.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      )}
      {!!entityTemplate?.data.formTemplateId && (
        <div className="form">
          <div className="label">Form Template</div>
          {form?.label}
          {(form?.type === 'pdf' || !form) && (
            <Alert colour="yellow" className="mt-2">
              This Task Template uses a PDF Form, which is no longer supported.
              Please delete this Task Template and create a new one using an
              alternative Task type.
            </Alert>
          )}
        </div>
      )}
    </div>
  );
};
export default EntityTemplateTaskReadView;
